<!-- This is a component that dynamically provides the required modal.
It takes a string as an argument, and renders the specific modal that is
matched by the string name -->
<template>
  <component
    :is="modalComponent.component"
    :data="modalComponent.data"
  />
</template>

<script>
import FormSubmittedModal from './FormSubmittedModal'
import FormModal from './FormModal'
import ConfirmNavigationModal from './ConfirmNavigation'
import TestModal from './TestModal'
import TestModal2 from './TestModal2'
import StandardConfirmation from './StandardConfirmation'
import Default from './Default'
import RegisterDomain from './RegisterDomain'
import AssignServices from './AssignServices'
export default {

  name: 'ContainerModal',
  props: {
    modalData: {
      type: [String, Object],
      default: null
    }
  },
  computed: {
    modalComponent () {
      const modalDetails = {}
      if (typeof this.modalData === 'string') {
        modalDetails.name = this.modalData
        modalDetails.data = {}
      } else {
        modalDetails.name = this.modalData.name
        modalDetails.data = this.modalData.data
      }
      switch (modalDetails.name) {
        case ('form-submitted'):
          return { component: FormSubmittedModal }
        case ('confirm-navigation'):
          return { component: ConfirmNavigationModal }
        case ('form-modal'):
          return { component: FormModal, data: modalDetails.data }
        case ('test'):
          return { component: TestModal }
        case ('confirmation'):
          return { ...modalDetails, component: StandardConfirmation }
        case ('register-domain'):
          return { component: RegisterDomain, data: modalDetails.data }
        case ('assign-services'):
          return { component: AssignServices, data: modalDetails.data }
        case ('test-2'):
          return { component: TestModal2 }
        default:
          return { component: Default }
      }
    }
  }
}
</script>
